/**
 * Created by yechuzheng on 2017/2/28.
 */

import {Injectable} from '@angular/core';

import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {isUndefined} from 'util';
import {NzMessageService} from 'ng-zorro-antd';
import {TokenCookieService} from './token-cookie.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    messageId: any;

    constructor(private router: Router, private _token: TokenCookieService, private _message: NzMessageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const access_token = this._token.get_cookie();
        if (!isUndefined(access_token)) {
            // this._auth.put_cookie(access_token);
            // console.log('已登录，可以访问 ' + state.url);
            return true;
        }


        if (!isUndefined(this.messageId)) {
            this._message.remove(this.messageId);
        }
        this.messageId = this._message.warning('页面不可直接访问，需要登录', {nzDuration: 3000, nzPauseOnHover: true}).messageId;
        // console.warn('需要登录', state.url);
        this.router.navigate(['/auth', 'login'], {queryParams: {returnUrl: state.url}});
        return false;
    }

}
